import React, { memo, useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { useAppContext } from '@context/AppContext';
import Button from '@components/Button';
import Link from '@components/Link';
import ClientOnlyPortal from '@components/Modal/ClientOnlyPortal';
import routes from '@utils/routes';
import { ApplySectionWrapper } from '@components/SingleOffer/styles';
import ApplyModal from '@components/ApplyModal';

interface ApplySectionProps {
  offer: Offer;
}

function ApplySection({ offer }: ApplySectionProps) {
  const [modalIsVisible, setModalIsVisible] = useState(false);
  const [applied, setApplied] = useState(offer.applied);
  const { isAuthenticated, userRole } = useAppContext();
  const { t } = useTranslation('offers');
  const { query, asPath, replace } = useRouter();

  const closeModalHandler = useCallback(() => {
    replace(asPath.split('?')[0]);
  }, [asPath, replace]);

  useEffect(() => {
    setModalIsVisible(!!query.apply);
  }, [query, setModalIsVisible]);

  if (!isAuthenticated) {
    return (
      <ApplySectionWrapper>
        <Link href={routes.signin}>{t('Login to apply')}</Link>
      </ApplySectionWrapper>
    );
  }

  if (userRole === 'student' && !applied) {
    return (
      <ApplySectionWrapper>
        <Button href={`${asPath}?apply=true`} shallow replace>
          {t('Apply')}
        </Button>

        <ClientOnlyPortal isOpen={modalIsVisible} closeHandler={closeModalHandler}>
          <ApplyModal offer={offer} cloaseHandler={closeModalHandler} setApplied={setApplied} />
        </ClientOnlyPortal>
      </ApplySectionWrapper>
    );
  }

  return null;
}

export default memo(ApplySection);
